// One root for every key this module owns, so a single invalidation of `all` reaches the
// lists (one per product) and the details (§8).
export const productLineItemsQueryKeys = {
    all: ['product-line-items'] as const,
    list: (productId: string) => ['product-line-items', 'list', productId] as const,
    detail: (id?: string) => ['product-line-items', 'detail', id] as const,
};
